import { Box, StatusLabel, Text, Title } from '@factorialco/deprecated-design-system'
import { FinanceValueObjectsInvoiceStatusEnum } from 'generated/resources/graphql'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { invoiceStatusTagType, mapStatusText } from 'modules/finance/lib/invoices'

interface BasicInformationProps {
  status: FinanceValueObjectsInvoiceStatusEnum
  createdAt?: string
  validatedAt?: string | null
}

export const BasicInformation = ({ status, createdAt, validatedAt }: BasicInformationProps) => {
  return (
    <Box paddingTop="s16" paddingBottom="s16" gap="s16">
      <Title
        variant="400"
        illustration="template"
        title={i18n.t('finance.invoices.detail.header')}
      />
      <Box flexDirection="row">
        <Box gap="s6" width="full" flexDirection="column">
          <Text weight="semibold" size="200">
            {i18n.t('finance.invoices.list.fields.payment_status')}
          </Text>
          <StatusLabel type={invoiceStatusTagType(status)}>{mapStatusText(status)}</StatusLabel>
        </Box>
        {createdAt && (
          <Box gap="s6" width="full" paddingLeft="s16">
            <Text weight="semibold" size="200">
              {i18n.t('finance.invoices.detail.fields.report_date')}
            </Text>
            <StatusLabel type="neutral">{dateBackendDateTimeToUI(createdAt)}</StatusLabel>
          </Box>
        )}
      </Box>
      <Box flexDirection="row">
        <Box gap="s6" width="full" flexDirection="column">
          <Text weight="semibold" size="200">
            {i18n.t('finance.invoices.list.fields.validation_status')}
          </Text>
          <StatusLabel type={validatedAt ? 'positive' : 'neutral'}>
            {validatedAt
              ? i18n.t('finance.invoices.list.status.validated')
              : i18n.t('finance.invoices.list.status.not_validated')}
          </StatusLabel>
        </Box>
      </Box>
    </Box>
  )
}
